<template>
  <div>
    <el-container class="container">
      <el-aside width="100%">
        <h2>{{routeTitle.substring(0, routeTitle.length - 2)}}分类</h2>
        <!-- <el-menu 
        v-for="(item,index) in leftMenu.navList" 
        :key="index" 
        unique-opened 
        :default-active="$route.path"
        :default-openeds="['订单管理']"
        mode="vertical"
        class="el-menu-vertical-demo"
        @select="activaSelect"
        @open="handleOpen"
        @close="handleClose">
          <component class="menu-item"
            :is="(item.children&&item.children.length>0)?'el-submenu':'el-menu-item'" :key="item.id" :index="item.title">
            <template slot="title">
              <span>{{item.catname}}</span>
            </template>
            <template v-if="item.arrchildid&&item.arrchildid.length>0">
              <el-menu-item class="menu-item" v-for="(v,i) in item.arrchildid" :key="i" :index="v.title">
                <span slot="title">{{v.arrchildid}}</span>
              </el-menu-item>
            </template>
          </component>
        </el-menu> -->
       
        <el-tree
        accordion
			node-key="catid"
			:data="navlist" 
			:props="defaultProps" 
			@node-click="handleNodeClick">
			<span class="custom-tree-node" slot-scope="{ node, data }">
				<span :title="node.label">{{ node.label }}</span>
			</span>
        </el-tree>
        <!-- <el-menu
          unique-opened
          :default-active="$route.path"
          class="el-menu-vertical-demo"
          mode="vertical"
          @select="activaSelect"
          @open="handleOpen"
          @close="handleClose">
          <el-menu-item :index="(item.catid).toString()" v-for="(item,index) in leftMenu.navList" :key="index">
            <span>{{item.catname}}</span>
          </el-menu-item>
        </el-menu> -->
      </el-aside>
       
    </el-container>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        leftMenu: {
          navList: []
        },        
        defaultProps: {
          children: 'children',
          label: 'catname'
        }
      }
    },
	props:{
		navlist:{
			type: Array
		}
	},
    mounted() {
    //   this.initNavList();
    },
    methods: {
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      activaSelect(key, keyPath){
        //console.log(key, keyPath);
        //发送catid到material父组件
        this.$emit('itemfun',key)
      },
      handleNodeClick(data) {
        this.$emit('itemfun',data.catid)
      }
    },
    created () {
      // 接收header导航传过来的name
      this.routeTitle = this.$route.query.name;
    },

  }
</script>

<style scoped>
h2 {
  padding: 0 20px;
}
.el-aside {
  overflow: initial;
  background-color: #fff;
}
.el-menu{
  border: 0;
}
.el-menu-item, .el-submenu__title {
  white-space: normal;
  display: flex;
  align-items: center;
}
.el-menu-item img {
  margin-right: 10px;
  width: 12px;
  height: 12px;
}
.el-icon-share::before {
  display: none;
}
.el-menu-item span{
  display: inline-block;
  line-height: 20px;
  width: calc(100% - 34px);
  color: #666;
}
.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    white-space: normal;
  }
  .container /deep/ .el-tree-node__content{
    height: auto;
    padding: 10px 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/navbar.vue